import { render } from "./SoldOutAsksComponent.vue?vue&type=template&id=1754bf60&scoped=true"
import script from "./SoldOutAsksComponent.vue?vue&type=script&lang=js"
export * from "./SoldOutAsksComponent.vue?vue&type=script&lang=js"

import "./SoldOutAsksComponent.vue?vue&type=style&index=0&id=1754bf60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1754bf60"]])

export default __exports__